<template>
  <b-modal
    :id="modalId"
    :ref="modalId"
    title="Adjuntar archivo desde el repositorio"
    ok-title="Vale"
    @ok="handleOk"
    data-cy= "save"
    size="xl"
    ok-only
  >
    <div>
      <MinimalDocumentManagement
        :add-file="addFile"
        :files="files"
        :show-principal-button="showPrincipalButton"
        :max-files="maxFiles"
      />
    </div>
  </b-modal>
</template>
<script>
import { BModal } from 'bootstrap-vue';

import MinimalDocumentManagement
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/MinimalDocumentManagement';

export default {
  components: { BModal, MinimalDocumentManagement },
  props: {
    showPrincipalButton: {
      type: Boolean,
      default: false
    },
    febosId: {
      type: String,
      required: false,
      default: ''
    },
    needFebosId: {
      type: Boolean,
      required: false,
      default: false
    },
    addFile: {
      type: Function
    },
    removeFile: {
      type: Function
    },
    files: {
      type: Array,
      default: () => []
    },
    modalId: {
      type: String,
      default: 'add-file-repository'
    },
    maxFiles: {
      type: Number
    }
  },
  data() {
    return {

    };
  },
  computed: {

  },
  methods: {
    handleOk() {

    }
  }
};
</script>
